module.exports = __webpack_public_path__ + "img/whiteAsset.7e4c8287.svg";